// extracted by mini-css-extract-plugin
export var copyableField = "_qx-4";
export var customerBadge = "_qx-0";
export var customerInfoTitle = "_qx-2";
export var details = "_qx-1";
export var dropdownContainer = "_qx-5";
export var dropdownImage = "_qx-6";
export var editAssigneeForm = "_qx-a";
export var editButton = "_qx-3";
export var email = "_qx-7";
export var hidden = "_qx-d";
export var input = "_qx-8";
export var saveButton = "_qx-b";
export var shopifyIcon = "_qx-c";
export var suggestionBadge = "_qx-e";
export var suggestionText = "_qx-f";
export var username = "_qx-9";